import React from "react";

import CartIcon from "../../icons/cart.svg";
import CarIcon from "../../icons/car.svg";

const BuyButton = ({
  label,
  articleNumber,
  quantityFieldId,
  href,
  cssClass,
  onClick,
  tooltip,
  tooltipcolor,
  disabled,
}) =>
  disabled ? (
    <a
      className={`disabled ${cssClass}`}
    >
      {cssClass.includes('show-button') && <CarIcon className="icon" viewBox="0 0 48 48" width="16" height="16" />}
      {!cssClass.includes('show-button') && <CartIcon className="icon" />}
      {label}
      {tooltip &&
        <div className={`buy-button__tooltip ${tooltipcolor}`}>
          {tooltip}
        </div>
      }
    </a>
  ) :
    articleNumber ? (
      <a
        className={cssClass}
        onClick={() => onClick(articleNumber, quantityFieldId)}
      >
        {cssClass.includes('show-button') && <CarIcon className="icon" viewBox="0 0 48 48" width="16" height="16" />}
        {!cssClass.includes('show-button') && <CartIcon className="icon" />}
        {label}
        {tooltip &&
          <div className={`buy-button__tooltip ${tooltipcolor}`}>
            {tooltip}
          </div>
        }
      </a>
    ) : (
      <a className={cssClass} href={href}>
          {cssClass.includes('show-button') && <CarIcon className="icon" viewBox="0 0 48 48" width="16" height="16" />}
          {!cssClass.includes('show-button') && <CartIcon className="icon" />}
        {label}
      </a>
    );

export default BuyButton;
